"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _SearcherAbstractFilters = _interopRequireDefault(require("./SearcherAbstractFilters"));
var _excluded = ["name"],
  _excluded2 = ["options", "activeFilters", "isMobile", "isHotelOnly"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var prepareOptions = function prepareOptions(options) {
  return options.map(function (option) {
    return {
      label: option.label,
      filters: option.filters.map(function (_ref) {
        var name = _ref.name,
          rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
        var labelName = function labelName() {
          return /*#__PURE__*/_react["default"].createElement("span", null, name);
        };
        return _objectSpread({
          name: labelName()
        }, rest);
      })
    };
  });
};
var prepareLabelFilter = function prepareLabelFilter(activeFilters, isMobile) {
  var activeFiltersCount = (0, _size2["default"])(activeFilters);
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.filters.title')), activeFiltersCount > 0 && /*#__PURE__*/_react["default"].createElement(ActiveCount, {
    isMobile: isMobile
  }, activeFiltersCount));
};
var SearcherFilters = function SearcherFilters(_ref2) {
  var options = _ref2.options,
    activeFilters = _ref2.activeFilters,
    _ref2$isMobile = _ref2.isMobile,
    isMobile = _ref2$isMobile === void 0 ? false : _ref2$isMobile,
    isHotelOnly = _ref2.isHotelOnly,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_SearcherAbstractFilters["default"], (0, _extends2["default"])({
    isFiltersMobile: false,
    isMobile: isMobile,
    label: prepareLabelFilter(activeFilters, isMobile),
    defaultValue: activeFilters,
    options: prepareOptions(options),
    position: "right",
    isHotelOnly: isHotelOnly
  }, props));
};
var ActiveCount = _styledComponents["default"].span.withConfig({
  displayName: "SearcherFilters__ActiveCount",
  componentId: "sc-m5j8j5-0"
})(["width:20px;height:20px;margin:0 4px;background-color:var(--secondary);position:relative;vertical-align:middle;bottom:", "px;display:inline-flex;border-radius:50%;justify-content:center;align-items:center;font-size:14px;font-style:normal;font-weight:400;line-height:16px;color:var(--white);"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 2 : 0;
});
var _default = exports["default"] = SearcherFilters;